module.exports = __webpack_public_path__ + "img/sms-icon2.4ff2a04f.svg";